//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class UserListModel extends ModelBase {
      static readonly $typeName = 'UserListModel';
      public displayName: string;
      public emailAddress: string;
      public identifier: string;
      public isAccountClosed: boolean;
      public isAccountDisabled: boolean;
      public isLocked: boolean;
      public isLoginAllowed: boolean;
      public key: string;
      public lockReason: string;
      public status: string;
      public fullName:string;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/UserListModel.ts